import splitComponentStyles from '../split-components';
import splitImageStyles from './split-image';

document.addEventListener('DOMContentLoaded', function () {
  var Five9URL = '';
  var auth = '';
  var yourDomain = '';
  var yourList = '';
  var callMeButton = document.getElementById('btnCallMe');
  var btnSubmit = document.getElementById('btnSubmitCallMe');
  if(callMeButton){
    var obj = JSON.parse(sessionStorage['quoteInfo']);
    callMeButton.addEventListener('click', (e) => {
      $('#divCallMeModel').modal($('body'));
      $('#divCallMeModel').modal('show');
      document.getElementById('txtEmail').value=obj.emailAddress;
    });
  }
  $("#frmCallMe").validate({
    onkeyup: true,
    onclick: false,
    onfocusout: false,
    focusInvalid: false,
    focusCleanup: true,
    highlight: function (element) {
      $(element).addClass("is-invalid");
    },
    unhighlight: function (element) {
      $(element).removeClass("is-invalid");
    },
    errorPlacement: function (error, element) {
      return true;
    },
    rules: {
      txtFirstName: { required: true },
      txtLastName: { required: true },
      txtPhoneNo: { phoneUS: true, required: true },
      txtEmail: { email: true, required: true }
    },
    messages: {
      txtFirstName: {
        required: helpers.formatRequiredFieldMessage("First Name")
      },
      txtLastName: {
        required: helpers.formatRequiredFieldMessage("Last Name")
      },
      txtEmail: {
        required: helpers.formatRequiredFieldMessage("Email Address")
      },
      txtPhoneNo: {
        required: helpers.formatRequiredFieldMessage("Phone Number")
      }
    }
  });

  if(btnSubmit){
    btnSubmit.addEventListener('click', (e) => {
      var fName = document.getElementById('txtFirstName');
      var lName = document.getElementById('txtLastName');
      var phoneNo = document.getElementById('txtPhoneNo');
      var email = document.getElementById('txtEmail');
      var isValied = true;
      if (!fName.value) {
        fName.classList.add("is-invalid");
        isValied = false;
      }
      if (!lName.value) {
        lName.classList.add("is-invalid");
        isValied = false;
      }
      if (!phoneNo.value) {
        phoneNo.classList.add("is-invalid");
        isValied = false;
      }
      if (isValied && $("#frmCallMe").valid()) {
        // var userKey = btoa('web2campaignTEST@pods.com' + ':' + 'mwusJFf^uH*JS9P_');
        // auth = userKey;
        // ShowButtonLoadingMessage('#btnSubmitCallMe');
        $('#btnSubmitCallMe').prop("disabled", true);
        GetFive9CallSettings();
        const fd = [
          `F9domain=${encodeURIComponent(yourDomain)}`,
          `F9list=${encodeURIComponent(yourList)}`,
          //`F9CallASAP=true`
        ];

        fd.push(`number1=${encodeURIComponent(phoneNo.value)}`);
        fd.push(`first_name=${encodeURIComponent(fName.value)}`);
        fd.push(`last_name=${encodeURIComponent(lName.value)}`);
        fd.push(`email=${encodeURIComponent(email.value)}`);
        sendHttpRequest('POST', Five9URL, fd.join('&'));
        //ShowConfirmation();
        return true;
      }
      $('#btnSubmitCallMe').prop("disabled", false);
      return false;
    });
  }

  function sendHttpRequest(method, url, data) {
    return fetch(url, {
      method: method,
        body: data,
        headers: {
          'Authorization': 'Basic:' + auth,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        redirect: 'follow'
    })
    .then(response => {
      if (response.status >= 200 && response.status < 300) {
        return response.text().then(retHtml => {
          console.info(retHtml);
          if (!ParseFive9Error(retHtml)) {
            // console.info(retHtml);
            ShowConfirmation();
            $('#btnSubmitCallMe').prop("disabled", false);
          }
        });
      } else {
        return response.json().then(errData => {
          console.log(errData);
          $('#btnSubmitCallMe').prop("disabled", false);
          throw new Error('Something went wrong - server-side.');
        });
      }
    })
    .catch(error => {
      console.log(error);
      $('#btnSubmitCallMe').prop("disabled", false);
      throw new Error('Something went wrong!');
    });
  };

  function ShowConfirmation() {
    $('#divCallMeModel').modal('hide');
    // document.getElementById("divCallMe").style.display = "none";
    // document.getElementById("divConfirmationMsg").style.display = "block";
    $('#divConfirmationContent').html();
    $('#divConfirmationModel').modal($('body'));
    $('#divConfirmationModel').modal('show');
  };

  function GetFive9CallSettings() {
    $.ajax({
      async: false,
      type: 'GET',
      async: false,
      url: '/api/sitecore/IFMoveThankYou/CallMeCampaignSettings',
      dataType: "json",
      data: {
    },
    success: function (data) {
      // console.log(data);
      Five9URL = data.Five9Url;
      auth = data.UserName + ':' + data.Password;
        yourDomain = data.Domain;
        yourList = data.ListName;
      },error: function (request, status, error) {
        alert(request.responseText);
      }
    });
  }

  function ParseFive9Error(response) {
    var span = document.createElement('span');
    var status = false;
    try{
      span.innerHTML = response;
      var children = span.querySelectorAll('*');
      for (var i = 0; i < children.length; i++) {
        if (children[i].id == "F9errCode" && children[i].value != "0") {
          status = true;
        }
        if (status && children[i].id == "F9errDesc") {
          alert(children[i].value);
          return true;
        }
      }
    }
    catch(ex){
      console.info('Some error in ParseFive9Error');
    }
    return status;
  };
}, false);
